// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { PartyCredentialRequirement } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { ProviderConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Provider';
import { ProviderService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useCreateProviderConfiguration: () => UseMutationResult<
  ContractId<ProviderConfiguration>,
  string,
  {
    providerServiceCid: ContractId<ProviderService>;
    holderRequirements: PartyCredentialRequirement[];
    registrarRequirements: PartyCredentialRequirement[];
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['createProviderConfiguration', ledgerApi],
    mutationFn: async ({ providerServiceCid, holderRequirements, registrarRequirements }) => {
      return ledgerApi.createRegistryProviderConfiguration(
        providerServiceCid,
        holderRequirements,
        registrarRequirements,
      );
    },
  });
};

export default useCreateProviderConfiguration;
